import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const Copy = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <path
        d='M15 9V4.25C15 3.56 14.44 3 13.75 3h-9.5C3.56 3 3 3.56 3 4.25v9.5c0 .69.56 1.25 1.25 1.25H9m1.25-6h9.5c.69 0 1.25.56 1.25 1.25v9.5c0 .69-.56 1.25-1.25 1.25h-9.5C9.56 21 9 20.44 9 19.75v-9.5C9 9.56 9.56 9 10.25 9'
        stroke='currentColor'
        strokeWidth='1.5'
      />
    ) : (
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M2 4a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v4h4a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H10a2 2 0 0 1-2-2v-4H4a2 2 0 0 1-2-2zm12.5 4H10a2 2 0 0 0-2 2v4.5H4a.5.5 0 0 1-.5-.5V4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 .5.5z'
        fill='currentColor'
      />
    )}
  </IconBase>
);
